<template>
  <DataTable
    v-model="dataModel"
    :value="dataModel"
    showGridlines
    responsiveLayout="scroll"
    :loading="!dataModel && mode != this.$FORM_MODE_CREATE"
  >
    <template #empty> No records found </template>
    <Column
      v-for="col of dataRequestLog"
      :field="col.field"
      :header="col.header"
      :key="col.field"
    >
      <template #body="{ data }" v-if="col.field.includes('Date')">
        {{ this.$formatDateTime(data.ActionDate) }}
      </template>
      <template #body="{ data }" v-if="col.field.includes('UrlWA')">
        <Button
          label="Send WA"
          @click="goToDetail(data)"
          severity="success"
          v-if="
            data.UrlWA != 'NO_PHONE_NUMBER' && data.UrlWA != 'NO_NEED_APPROVE'
          "
        />
        <div v-else-if="data.UrlWA == 'NO_PHONE_NUMBER'">No Phone Number</div>
        <div v-else-if="data.UrlWA == 'NO_NEED_APPROVE'"></div>
        <div v-else></div>
      </template>
      <template #body="{ data }" v-if="col.field.includes('DownloadJsea')">
        <div v-if="processed" style="float: right !important">
          <ProgressSpinner style="width: 20px; height: 20px" />
        </div>
        <Button
          label="Download"
          autofocus
          icon="pi pi-download"
          class="pi-button p-button-success"
          @click="goToDownloadJsea(data)"
          v-if="!processed"
        />
      </template>
    </Column>
  </DataTable>

  <FileViewer
    v-if="dialogVisibleView"
    :isVisible="dialogVisibleView"
    :urlFile="this.fileUrlView"
    :isPdf="this.isPdf"
    :isImg="this.isImg"
    :fileNames="this.fileName"
    :sectionFile="this.sectionFile"
    @hide="hideViewer"
    @block-ui="blockUI"
    @unblock-ui="unblockUI"
  />
</template>

<script>
import { ref, watch } from "vue";
export default {
  name: "RequestLogDataTable",
  props: {
    modelValue: {
      type: Object,
      default: null,
    },
    dataRequestLog: {
      type: Array,
      default: null,
    },
    mode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      processed: false,
      dataModel: this.modelValue,
      fileUrlView: null,
      fileUrl: null,
      fileName: null,
      fileTypeView: null,
      fileHref: null,
      isImg: false,
      isPdf: false,
      dialogVisibleView: false,
      sectionFile: null,
    };
  },
  mounted() {
    // Watch for changes in externalData
    watch(
      () => this.modelValue,
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          // Update the tableData when externalData changes
          this.dataModel = newValue;
        }
      }
    );
  },
  methods: {
    goToDetail(data) {
      let routeData = data.UrlWA;
      window.open(routeData, "_blank");
    },
    goToDownloadJsea(data) {
      this.processed = true;
      this.$emit("block-ui");
      //console.log(file)

      var self = this;
      this.$axios
        .get(
          this.$API_URL +
            "work/download_currently_jsealog/" +
            data.DownloadJsea,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          self.fileTypeView = self.getFileType(data.JseaName);
          if (self.fileTypeView && self.fileTypeView.startsWith("image/")) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            self.fileUrlView = url;
            self.fileName = data.JseaName;
            self.fileUrl = url;
            self.isImg = true;
          }

          if (self.fileTypeView === "application/pdf") {
            const blob = new Blob([response.data], { type: "application/pdf" });
            self.fileUrlView = window.URL.createObjectURL(blob);
            self.fileName = data.JseaName;
            self.isPdf = true;
          }
          self.sectionFile = data.JseaNumber;
          self.processed = false;
          self.dialogVisibleView = true;

          self.$emit("unblock-ui");
        })
        .catch(function (err) {
          self.$parent.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "File not found" + err,
            life: 3000,
          });
          self.blocked = false;
          self.$emit("unblock-ui");
          //self.showAssignModal = false;
        });
    },
    getFileType(fileName) {
      const extension = fileName.split(".").pop().toLowerCase();
      switch (extension) {
        case "pdf":
          return "application/pdf";
        case "jpg":
        case "jpeg":
          return "image/jpeg";
        case "png":
          return "image/png";
        default:
          return "application/octet-stream";
      }
    },
    hideViewer() {
      this.dialogVisibleView = false;
      this.fileUrl = null;
      this.fileName = null;
      this.fileTypeView = null;
      this.fileHref = null;
      this.isImg = false;
      this.isPdf = false;
    },
  },
};
</script>
